import React, { useEffect, useRef, useState, } from 'react';
import { Link, } from 'react-router-dom';

import axios from 'axios';
import $ from 'jquery';

import Swal from 'sweetalert2';
import HtmlParser from 'react-html-parser';

import moment from 'moment-timezone';
import 'react-tempusdominus-bootstrap';

import { Tooltip, } from 'bootstrap';

//#region Fullcalendar
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import allLocales from '@fullcalendar/core/locales-all';
import interactionPlugin from '@fullcalendar/interaction'
//#endregion Fullcalendar

import useAuth from '../../controllers/users/useAuth';

import {
    checkIfUserIsMaster, responseGet, globalSettings, styles, sendMessageCloseCurrentWindowAsync, dateTimeFormatGlobalSet, charactersRemainingGet, statusGet, textByNumericStatus, checkIfCallPrinterAsync,
    languageObjGet, isUndNullEmp, LoadingSection,
} from '../../helpers/settings';
import Menu from '../main/Menu';
import { buildingsByUserGetAsync, userApartmentsGetAsync } from '../../controllers/apartments/apartmentUsers';
import { reserveCommonAreaModelGet } from '../../models/reserveCommonAreas/reserveCommonArea';
import BuildingHeader from '../buildings/BuildingHeader';
import { GlobalFormats } from '../../classes/main/globalFormats';
import { userModelGet } from '../../models/users/user';
import { buildingModelGet } from '../../models/buildings/building';
import { apartmentModelGet } from '../../models/apartments/apartment';
import { apartmentUserModelGet } from '../../models/apartments/apartmentUser';
import { commonAreaModelGet } from '../../models/commonArea/commonArea';

const currentMethod = 'ReserveCommonAreas';

const { app, collections: dbColle, labels, messages, react, } = globalSettings;
const { properties: dbProps, } = dbColle;
const { backend, } = app;
const { operators: dbOpera, } = react?.firebase;

export default function ReserveCommonAreas({
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region variables
    let result;
    let dataObj = {};
    let headerObj = {};
    const auth = useAuth();
    let swalProperties = {};
    const [isChangeStatus, setIsChangeStatus] = useState(false);
    const [statusCommentShow, setStatusCommentShow] = useState(false);
    const [showData, setShowData] = useState(false);
    const [showLoading, setShowLoading] = useState({ buildings: true, reserveCommonAreas: true, });
    const userRole = checkIfUserIsMaster({ email: auth?.user?.email || '', languageId: languageObj?.id, subMethod: currentMethod, })?.result;
    const [processValues, setProcessValues] = useState({
        type: 0,
        status: statusGet({ languageId: languageObj?.id, subMethod: currentMethod, }),
        titleTypes: textByNumericStatus({ languageId: languageObj?.id, subMethod: currentMethod, }),
        user: userModelGet({}),
    });
    let tooltipInstance = null;
    //#endregion variables

    //#region calendar settings
    const fullCalendarRef = useRef(FullCalendar);
    const [calendarEvents, setCalendarEvents] = useState([]);
    const [enableCalendarEventMouseEnter, setEnableCalendarEventMouseEnter] = useState(false);

    const calendarSettings = {
        buttonText: {
            today: labels?.today?.[languageObj?.id],
            month: labels?.month?.[languageObj?.id],
            week: labels?.week?.[languageObj?.id],
            day: labels?.day?.[languageObj?.id],
            list: labels?.list?.[languageObj?.id],
        },
        droppable: true,
        editable: true,
        eventClick: async function (info) {
            const subMethod = '';
            const currentMethod = 'calendarSettings / eventClick';
            let response = responseGet();
            try {
                if (enableCalendarEventMouseEnter) {
                    if (tooltipInstance) {
                        tooltipInstance.dispose();
                        tooltipInstance = null;
                    }
                }
                await calendarEventClickAsync({ data: info, subMethod: currentMethod, });
            } catch (ex) {
                response.msgType = -1;
                response.isSuccess = false;
                response.msgText = `Method: ${currentMethod}<br/>`;
                if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                    response.msgText += `Sub method: ${subMethod}<br/>`;
                }
                response.msgText += `Error: ${ex?.message}`;
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
            }
        },
        eventMouseEnter: async function (info) {
            const subMethod = '';
            const currentMethod = 'calendarSettings / eventMouseEnter';
            let response = responseGet();
            try {
                if (enableCalendarEventMouseEnter) {
                    //#region dateTime object
                    const dateTimeObj = {
                        dateFormat: languageObj?.format?.date?.f1,
                        timeFormat: languageObj?.format?.time?.type,
                        start: '',
                        end: ''
                    };
                    dateTimeObj.start = dateTimeFormatGlobalSet({
                        date: info?.event?.start,
                        type: dateTimeObj?.dateFormat,
                        format: dateTimeObj?.timeFormat,
                        addTime: false,
                        secondsShow: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    })?.result;
                    dateTimeObj.end = dateTimeFormatGlobalSet({
                        date: info?.event?.end,
                        type: dateTimeObj?.dateFormat,
                        format: dateTimeObj?.timeFormat,
                        addTime: false,
                        secondsShow: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    })?.result;
                    //#endregion dateTime object

                    //#region title object
                    let titleLocal = `<div class='text-left text-sm' style="font-size:4px">`;
                    //localTitle += ` ${labels?.startDate?.[languageObj?.id]}:<br/>`;
                    titleLocal += ` ${labels?.from?.[languageObj?.id]}:<br/>`;
                    //titleLocal += ` ${dateTimeFormatGlobalSet(info?.event?.start, globalSettings?.react?.tempusDominus?.format?.date?.dmy, 12, false).result}<br/>`;
                    titleLocal += ` ${dateTimeObj?.start}<br/>`;
                    //localTitle += ` ${labels?.endDate?.[languageObj?.id]}:<br/>`;
                    titleLocal += ` ${labels?.to?.[languageObj?.id]}:<br/>`;
                    //titleLocal += ` ${dateTimeFormatGlobalSet(info?.event?.end, globalSettings?.react?.tempusDominus?.format?.date?.dmy, 12, false).result}`;
                    titleLocal += ` ${dateTimeObj?.end}<br/>`;
                    titleLocal += `</div>`;
                    //#endregion title object

                    //#region toolTip
                    tooltipInstance = new Tooltip(
                        info.el,
                        {
                            //title: info?.event?.title,
                            title: titleLocal,
                            //template: titleLocal,
                            html: true,
                            placement: 'top',
                            trigger: 'hover',
                            container: 'body',

                        },

                    );

                    tooltipInstance?.show();
                    //#endregion toolTip
                }
            } catch (ex) {
                response.msgType = -1;
                response.isSuccess = false;
                response.msgText = `Method: ${currentMethod}<br/>`;
                if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                    response.msgText += `Sub method: ${subMethod}<br/>`;
                }
                response.msgText += `Error: ${ex?.message}`;
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
            }
        },
        eventMouseLeave: async function () {
            const subMethod = '';
            const currentMethod = 'calendarSettings / eventMouseLeave';
            let response = responseGet();
            try {
                if (enableCalendarEventMouseEnter) {
                    if (tooltipInstance) {
                        tooltipInstance.dispose();
                        tooltipInstance = null;
                    }
                }
            } catch (ex) {
                response.msgType = -1;
                response.isSuccess = false;
                response.msgText = `Method: ${currentMethod}<br/>`;
                if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                    response.msgText += `Sub method: ${subMethod}<br/>`;
                }
                response.msgText += `Error: ${ex?.message}`;
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
            }
        },
        events: calendarEvents,
        headerToolbar: {
            left: 'prev,next today',
            center: 'title',
            right: 'dayGridMonth,timeGridWeek,timeGridDay'
        },
        initialView: ['dayGridMonth'],
        //locale: 'es',
        locale: languageObj?.id,
        locales: allLocales,
        plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
        themeSystem: 'bootstrap5',
    };
    //#endregion calendar settings

    //#region reserve common area
    const reserveDateFromId = 'reserveDateFrom';
    //const reserveDateFromInputId = 'reserveDateFromInput';
    const reserveDateToId = 'reserveDateTo';
    //const reserveDateToInputId = 'reserveDateToInput';
    const commentMaxLength = 150;
    const statusCommentMaxLength = 150;
    //const statusId = 'status';
    const [btnSyncDisabled, setBtnSyncDisabled] = useState(true);
    const [reserveCommonArea, setReserveCommonArea] = useState(reserveCommonAreaModelGet('', '', '', auth?.user?.uid));
    const [apartmentUsersError, setApartmentUsersError] = useState('');
    const [commonAreasError, setCommonAreasError] = useState('');
    const [dateFromError, setDateFromError] = useState('');
    const [dateToError, setDateToError] = useState('');
    const [commentError, setCommentError] = useState('');
    const [commentRemaining, setCommentRemaining] = useState('');
    const [statusCommentError, setStatusCommentError] = useState('');
    const [statusCommentRemaining, setStatusCommentRemaining] = useState('');
    const [statusError, setStatusError] = useState('');
    const [statusUser, setStatusUser] = useState({});
    const [statusUserError, setStatusUserError] = useState('');
    //#endregion reserver common area

    //#region buildings
    const buildingsId = 'buildings';
    const [buildingId, setBuildingId] = useState('');
    const [building, setBuilding] = useState(buildingModelGet({}));
    const [buildings, setBuildings] = useState([buildingModelGet({})]);
    //#endregion buildings

    //#region apartments
    //const apartmentsId = 'apartments';
    const [apartmentUsers, setApartmentUsers] = useState([apartmentUserModelGet({})]);
    //#endregion apartments

    //#region Common areas
    //const commonAreasId = 'commonAreas';
    const [commonAreas, setCommonAreas] = useState([commonAreaModelGet({})]);
    //#endregion Common areas

    //#region others
    const controls = {
        buttons: {
            save: {
                className: 'btn btn-sm btn-outline-primary mx-1',
                id: 'btnSave',
            },
            new: {
                className: 'btn btn-sm btn-outline-success',
                id: 'btnNew',
            },
        },
        checkBox: {
            // remenberMe: {
            //     attributes: {
            //     },
            //     id: 'chkRemenberMe',
            // },
        },
        dataTables: {
            // s: {
            //     inputs: {
            //         search: {
            //             id: `${dtId}_filter input`,
            //             className: '',
            //         },
            //     },
            //     selects: {
            //         entries: {
            //             id: `${dtId}_length select`,
            //             className: '',
            //         },
            //     },
            // },
        },
        icons: {
            save: {
                id: 'iconSave',
                className: globalSettings?.icons?.save,
            },
            new: {
                id: 'iconNew',
                className: globalSettings?.icons?.fileFar,
            },
        },
        inputs: {
            dateFrom: {
                id: 'inputDateFrom',
                className: 'form-control datetimepicker-input',
            },
            dateTo: {
                id: 'inputDateTo',
                className: 'form-control datetimepicker-input',
            },
            comment: {
                id: 'inputComment',
                className: 'form-control',
            },
            commentStatus: {
                id: 'inputCommentStatus',
                className: 'form-control bg-transparent text-black',
            },
        },
        selects: {
            apartment: {
                id: 'selApartment',
                className: 'form-select',
            },
            commonArea: {
                id: 'selCommonArea',
                className: 'form-select',
            },
            status: {
                id: 'selStatus',
                className: 'form-select bg-transparent text-black',
            },
        },
        spinners: {
            new: {
                id: 'spNew',
                className: '',
            },
            save: {
                id: 'spSave',
                className: '',
            },
        },
        urls: {
            // forgotYourPassword: {
            //     id: 'urlForgotYourPassword',
            //     className: 'btn-link',
            // },
            // reCaptchaPrivaciConditions: {
            //     id: 'urlReCaptchaPrivaciConditions',
            //     className: '',
            // },
            // userRegister: {
            //     id: 'urlRequestAccount',
            //     className: '',
            // },
            // registerStatus: {
            //     id: 'urlStatusRegister',
            //     className: '',
            // },
        },
    };
    //#endregion others

    //#region reserve common area (methods)
    const reserveCommonAreasGetAsync = async ({ e = {}, processType_ = '', subMethod = '', }) => {
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e?.preventDefault, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            //#region variables
            processType_ = processType_ === 's' || processType_ === 'b' ? '' : processType_;

            let isEditLocal = false;
            let buildingIdLocal = '';
            let buildingLocal = buildingModelGet({});
            let apartmentsLocal = [apartmentModelGet({})];
            let reserveCommonAreasLocal = [reserveCommonAreaModelGet({})];
            //#endregion variables

            setShowLoading({ buildings: false, reserveCommonAreas: true, });
            //setShowData(false);

            //#region initialize
            setBuilding({});
            setCalendarEvents([]);
            setApartmentUsers([]);
            setBtnSyncDisabled(true);
            //#endregion initialize

            //#region get reserve common area
            //#region old code
            // if (!isUndefined(e) && !isNull(e)) {
            //     localBuildingId = e?.target?.value;
            //     setBuildingId(localBuildingId);
            // } else {
            //     localBuildingId = !isUndefined(buildingId) && !isNull(buildingId) && !isEmpty(buildingId) ? buildingId : processType_;
            // }
            //#endregion old code

            buildingIdLocal = $(`#${buildingsId}`)?.val();
            setBuildingId(buildingIdLocal);

            setReserveCommonArea(
                reserveCommonAreaModelGet({
                    buildingId: buildingIdLocal,
                    apartmentId: '',
                    commonAreaId: '',
                    userId: auth?.user?.uid
                })
            );

            if (!isUndNullEmp({ data: buildingIdLocal, subMethod: currentMethod, })?.result) {
                //#region old code
                //let localBuilding = buildings.filter(({ id }) => id === localBuildingId);
                //localBuilding = isArray(localBuilding) ? localBuilding[0] : localBuilding;
                //#endregion old code

                buildingLocal = buildings?.filter(({ id, }) => id === buildingIdLocal)?.[0] || {};
                setBuilding(buildingLocal);

                //#region  Get data
                if (!isUndNullEmp({ data: buildingLocal, subMethod: currentMethod, })?.result) {
                    //#region get reserve common areas
                    response = await reserveCommonAreasWithDetailsByIdGetAsync({
                        id: '',
                        buildingId: buildingIdLocal,
                        subMethod: currentMethod,
                    });

                    if (!response?.isSuccess || response?.isWarning) {
                        setShowLoading({ buildings: false, reserveCommonAreas: false, });
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });
                        return;
                    }

                    reserveCommonAreasLocal = response.result;
                    //#endregion get reserve common areas

                    //#region apartments
                    response = await userApartmentsGetAsync({
                        buildingId: buildingIdLocal,
                        auth: auth,
                        userRole: userRole,
                        method: backend?.methods?.apartmentUsersWithDetails,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });

                    if (!response?.isSuccess || response?.isWarning) {
                        setShowLoading({ buildings: false, reserveCommonAreas: false, });
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });
                        return;
                    }

                    apartmentsLocal = response?.result?.apartmentUsers;
                    //#endregion apartments

                    //#region Common areas
                    if (!isUndNullEmp({ data: buildingLocal?.commonAreas, subMethod: currentMethod, })?.result && buildingLocal?.commonAreas?.length > 0) {
                        setCommonAreas(buildingLocal?.commonAreas);
                    } else {
                        setShowLoading({ buildings: false, reserveCommonAreas: false, });
                        response.msgType = 1;
                        response.msgText = `${messages?.youMustCreateLeastOneCommonArea?.[languageObj?.id]}<br/>`;
                        response.msgText += `${messages?.goTo?.[languageObj?.id]} <a href='/buildingEdit/${buildingIdLocal}'>${labels?.commonAreas?.[languageObj?.id]}<a/>`;
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });
                        return;
                    }
                    //#endregion Common areas

                    //#region set calendar events
                    if (!isUndNullEmp({ data: reserveCommonAreasLocal, subMethod: currentMethod, })?.result && reserveCommonAreasLocal?.length > 0) {
                        response = await calendarEventSetAsync({
                            data: reserveCommonAreasLocal,
                            subMethod: currentMethod,
                        });

                        if (!response?.isSuccess || response?.isWarning) {
                            setShowLoading({ buildings: false, reserveCommonAreas: false, });
                            return;
                        }
                    }
                    //#endregion set calendar events

                    //#region set is edit / delete
                    isEditLocal = buildingLocal?.process?.edit || false;
                    //#endregion set is edit / delete

                    //#region set if is or not commont user
                    setIsChangeStatus(isEditLocal);
                    //#endregion set if is or not commont user

                    setApartmentUsers(apartmentsLocal);
                    setBtnSyncDisabled(false);
                }
                //#endregion  Get data
            }
            //#endregion get reserve common area

            //#region dateTime in control sets
            response = await dateInControlSetAsync({
                date: new Date(),
                dateFrom: reserveCommonArea?.dateFrom,
                dateTo: reserveCommonArea?.dateTo,
                processType: 0,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ buildings: false, reserveCommonAreas: false, });
                //await sendMessageCloseCurrentWindowAsync(response.msgType, replaceMessages(0, response.msgText).result, false, response.urlGoTo, auth, false);
                return;
            }
            //#endregion dateTime in control sets

            setShowLoading({ buildings: false, reserveCommonAreas: false, });
        } catch (ex) {
            setShowLoading({ buildings: false, reserveCommonAreas: false, });
            setBtnSyncDisabled(true);
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const reserveCommonAreaAddEditDetailsDeleteGetAsync = async ({ e, id = '', description = '', data = {}, processType = 0, subMethod = '', }) => {
        const currentMethod = 'reserveCommonAreaAddEditDetailsDeleteGetAsync';
        let response = responseGet();
        try {
            //#region set initialize
            if (isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }
            //#endregion set initialize

            //#region set initial data
            const buildingIdLocal = $(`#${buildingsId}`)?.val();
            //#endregion set initial data

            //#region error default set
            response = await errorDefaultSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion error default set

            //#region building validate
            if (isUndNullEmp({ data: buildingIdLocal, subMethod: currentMethod, })?.result) {
                await sendMessageCloseCurrentWindowAsync({
                    msgType: 1,
                    msgText: messages?.youMustSelectBuilding?.[languageObj?.id],
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion building validate

            //#region validate data set
            //#region old code
            // if (processType !== -1) {
            //     //#region data set

            //     response = reserveCommonAreaDataSet();
            //     if (!response?.isSuccess || response?.isWarning) {
            //         await sendMessageCloseCurrentWindowAsync(response.msgType, replaceMessages(0, response.msgText).result, false, response.urlGoTo, auth, false);
            //         return;
            //     }

            //     //#endregion data set

            //     //#region validate data

            //     response = await formDataValidateAsync();
            //     if (!response?.isSuccess || response?.isWarning) {
            //         return;
            //     }
            //     //#endregion validate data
            // }
            //#endregion old code
            //#endregion validate data set

            //#region get reserve common area
            if (processType > 0) {
                //#region set reserve common area
                const reserveCommonAreaLocal = {
                    id: data?.event?.id,
                    buildingId: data?.event?.extendedProps?.buildingId,
                    apartmentId: data?.event?.extendedProps?.apartment?.id,
                    commonAreaId: data?.event?.extendedProps?.commonArea?.id,
                    userId: data?.event?.extendedProps?.user?.id,
                    comment: data?.event?.extendedProps?.comment,
                    created: data?.event?.extendedProps?.created,
                    dateFrom: data?.event?.start,
                    dateTo: data?.event?.end,
                    status: data?.event?.extendedProps?.status?.type,
                    statusComment: data?.event?.extendedProps?.status?.comment,
                    statusDate: data?.event?.extendedProps?.status?.date,
                    statusUserId: data?.event?.extendedProps?.status?.userId,
                };

                setReserveCommonArea(reserveCommonAreaLocal);
                setStatusUser(data?.event?.extendedProps?.status?.user);
                //#endregion set reserve common area

                //#region set status comment (show)
                setStatusCommentShow((reserveCommonAreaLocal?.status > 1));
                //#endregion set status comment (show)

                //#region set datetime in controls
                response = await dateInControlSetAsync({
                    date: undefined,
                    dateFrom: reserveCommonAreaLocal?.dateFrom,
                    dateTo: reserveCommonAreaLocal?.dateTo,
                    processType: 1,
                    subMethod: currentMethod,
                });

                if (!response?.isSuccess || response?.isWarning) {
                    return;
                }
                //#endregion set datetime in controls

                //#region set comment remaining
                setCommentRemaining(
                    charactersRemainingGet({
                        text: reserveCommonAreaLocal?.comment,
                        maxLength: commentMaxLength,
                        msgText: `${messages?.charactersRemaining?.[languageObj?.id]}:`,
                        subMethod: currentMethod,
                    })?.result
                );
                //#endregion set comment remaining

                //#region set comment remaining (status)
                setStatusCommentRemaining(
                    charactersRemainingGet({
                        text: reserveCommonAreaLocal?.statusComment,
                        maxLength: statusCommentMaxLength,
                        msgText: `${messages?.charactersRemaining?.[languageObj?.id]}:`,
                        subMethod: currentMethod,
                    })?.result
                );
                //#endregion set comment remaining (comment)
            } else if (processType === -1) {
                setProcessValues({ ...processValues, type: 0 });
                //#region old code
                //response = await reserveCommonAreaDeleteAsync(id, buildingIdLocal, description);
                //response = await reserveCommonAreaDeleteAsync({id: id, description: description, subMethod: currentMethod, });
                // if (!response?.isSuccess || response?.isWarning) {
                //     return;
                // }
                //#endregion old code
                reserveCommonAreaDeleteAsync({ id: id, description: description, subMethod: currentMethod, });
            }
            //#endregion get reserve common area
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const reserveCommonAreaAddAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'reserveCommonAreaAddAsync';
        let response = responseGet();
        try {
            //#region set initialize
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }
            //#endregion set initialize

            //#region set initial data
            let eventLocal = {};
            const buildingIdLocal = $(`#${buildingsId}`)?.val();
            let reserveCommonAreaLocal = reserveCommonAreaModelGet({});
            const fullCalendarAPILocal = fullCalendarRef.current.getApi();
            //#endregion set initial data

            //#region error default set
            response = await errorDefaultSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion error default set

            //#region building validate
            if (isUndNullEmp({ data: buildingIdLocal, subMethod: currentMethod, })?.result) {
                await sendMessageCloseCurrentWindowAsync({
                    msgType: 1,
                    msgText: messages?.youMustSelectBuilding?.[languageObj?.id],
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion building validate

            //#region validate data set
            //#region data set
            response = await reserveCommonAreaDataSet({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion data set

            //#region set status
            if(!isChangeStatus && reserveCommonArea?.status === -1){
                reserveCommonArea.status = 0;
                reserveCommonArea.statusUserId = auth?.user?.uid;
            }
            //#endregion set status

            //#region validate data
            response = await formDataValidateAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion validate data

            //#endregion validate data set
            controlsStatusSet({ processType: 1, subMethod: currentMethod, });

            //#region create data
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                },
            };

            reserveCommonArea.returnDetails = true;

            dataObj = {
                reserveCommonArea: reserveCommonArea,
                withDetails: true,
                languageId: languageObj?.id,
                url: `${backend?.url}${backend?.urlApiV1}${backend?.urlReserveCommonAreas}/`,
            };

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj,
            );

            response = result?.data;

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            reserveCommonAreaLocal = response?.result;
            //#endregion create data

            //#region set event data
            response = await evenDataSetAsync({
                data: reserveCommonAreaLocal,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            eventLocal = response?.result;
            fullCalendarAPILocal?.addEvent(eventLocal);
            //#endregion set event data

            //#region from data clear
            response = await formDataClearAsync({
                e: null,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion from data clear

            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            await sendMessageCloseCurrentWindowAsync({
                msgType: 0,
                msgText: messages?.processesCompletedSuccessfully?.[languageObj?.id],
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const reserveCommonAreaEditAsync = async ({ e = {}, id = '', description = '', subMethod = '', }) => {
        const currentMethod = 'reserveCommonAreaEditAsync';
        let response = responseGet();
        try {
            //#region set initialize
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }
            //#endregion set initialize

            //#region set initial data
            let eventLocal = {};
            let eventObjLocal = null;
            const buildingIdLocal = $(`#${buildingsId}`)?.val();
            let reserveCommonAreaLocal = reserveCommonAreaModelGet({});
            let fullcalendarAPILocal = fullCalendarRef?.current?.getApi();
            //#endregion set initial data

            //#region error default set
            response = await errorDefaultSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion error default set

            //#region building validate
            if (isUndNullEmp({ data: buildingIdLocal, subMethod: currentMethod, })?.result) {
                await sendMessageCloseCurrentWindowAsync({
                    msgType: 1,
                    msgText: messages?.youMustSelectBuilding?.[languageObj?.id],
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion building validate

            //#region validate data set
            //if (processValues.type !== -1) {
            //#region data set
            response = await reserveCommonAreaDataSet({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion data set

            //#region validate data
            response = await formDataValidateAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion validate data
            //}
            //#endregion validate data set

            //#region get reserve common area
            if (processValues?.type === 1) {
                //#region update data
                controlsStatusSet({ processType: 1, subMethod: currentMethod, });

                headerObj = {
                    headers: {
                        authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                    },
                };

                dataObj = {
                    reserveCommonArea: reserveCommonArea,
                    withDetails: true,
                    languageId: languageObj?.id,
                    url: `${backend?.url}${backend?.urlApiV1}${backend?.urlReserveCommonAreas}/${reserveCommonArea?.id}`,
                };

                result = await axios?.post(
                    dataObj?.url,
                    dataObj,
                    headerObj,
                );

                response = result?.data;

                if (!response?.isSuccess || response?.isWarning) {
                    controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: response?.msgType,
                        msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                        closeWindow: false,
                        urlGoTo: response?.urlGoTo,
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                    return;
                }

                reserveCommonAreaLocal = response?.result;
                //#endregion pdate data

                //#region update event
                //#region set object event
                response = await evenDataSetAsync({
                    data: reserveCommonAreaLocal,
                    subMethod: currentMethod,
                });

                if (!response?.isSuccess || response?.isWarning) {
                    controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                    return response;
                }

                eventLocal = response?.result;
                //#endregion set object event

                eventObjLocal = fullcalendarAPILocal?.getEventById(reserveCommonAreaLocal?.id);
                eventObjLocal?.remove();
                fullcalendarAPILocal?.addEvent(eventLocal);
                //#endregion update event

                controlsStatusSet({ processType: 0, subMethod: currentMethod, });

                await sendMessageCloseCurrentWindowAsync({
                    msgType: 0,
                    msgText: messages?.processesCompletedSuccessfully?.[languageObj?.id],
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
            }
            //#endregion get reserve common area

            //#region from data clear
            response = await formDataClearAsync({
                e: null,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                return;
            }
            //#endregion from data clear
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    //#region old code
    // const reserveCommonAreaDeleteAsync = async ({ id = '', buildingId = '', description = '', subMethod = '', }) => {
    //     const currentMethod = 'reserveCommonAreaDeleteAsync';
    //     let response = responseGet();
    //     try {
    //         //#region variables
    //         const fullCalendarAPILocal = fullCalendarRef?.current?.getApi();
    //         //#endregion variables

    //         //#region show message

    //         let msgText = `${labels?.title?.[languageObj?.id]}:<br/>`;
    //         msgText += `<b>${description}</b><br/>`;
    //         msgText += `${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`;

    //         swalProperties = {
    //             icon: globalSettings?.react?.sweetAlert2?.icons?.warning,
    //             title: messages?.areYouSureDeleteThis?.[languageObj?.id],
    //             html: msgText,
    //             timer: null,
    //             confirmButtonColor: globalSettings?.colors?.warningColorExp,
    //             confirmButtonText: labels?.yes?.[languageObj?.id],
    //             showCancelButton: true,
    //             cancelButtonColor: globalSettings?.colors?.successColorExp,
    //             cancelButtonText: labels?.no?.[languageObj?.id],
    //             timerProgressBar: false,
    //             didOpen: () => {
    //                 Swal.hideLoading();
    //             },
    //         };

    //         const { isConfirmed, } = await Swal.fire(swalProperties);

    //         //#endregion show message

    //         //#region delete data

    //         if (isConfirmed) {
    //             sendMessage(2, messages?.processing?.[languageObj?.id], globalSettings?.timers?.thirtySeconds, false, true, null, '');

    //             //#region delete data

    //             headerObj = {
    //                 headers: {
    //                     authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
    //                 },
    //             };

    //             //result = await axios.delete(`${backend?.urlDev}${backend?.urlApiV1}${backend?.urlReserveCommonAreas}/${id}`, headerObj);
    //             result = await axios.delete(`${backend?.url}${backend?.urlApiV1}${backend?.urlReserveCommonAreas}/${id}`, headerObj);
    //             response = result.data;

    //             if (!response?.isSuccess || response?.isWarning) {
    //                 return response;
    //             }

    //             //#endregion delete data

    //             //#region delete event

    //             const localEventObj = fullCalendarAPILocal.getEventById(id);
    //             localEventObj.remove();

    //             //#endregion delete event

    //             await sendMessageCloseCurrentWindowAsync(0, messages?.processesCompletedSuccessfully?.[languageObj?.id], false, response.urlGoTo, auth, false);
    //         }

    //         //#endregion delete data
    //     } catch (ex) {
    //         response.msgType = -1;
    //         response.isSuccess = false;
    //         response.msgText = `Method: ${currentMethod}<br/>`;
    //         if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
    //             response.msgText += `Sub method: ${subMethod}<br/>`;
    //         }
    //         response.msgText += `Error: ${ex?.message}`;
    //         await sendMessageCloseCurrentWindowAsync({
    //             msgType: response?.msgType,
    //             msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
    //             closeWindow: false,
    //             urlGoTo: response?.urlGoTo,
    //             auth: auth,
    //             isLogout: false,
    //             languageId: languageObj?.id,
    //             subMethod: currentMethod,
    //         });
    //     }
    //     return response;
    // }
    //#endregion old code

    const reserveCommonAreaDeleteAsync = async ({ id = '', description = '', subMethod = '', }) => {
        const currentMethod = 'reserveCommonAreaDeleteAsync';
        let response = responseGet();
        try {
            //#region variables
            const fullCalendarAPILocal = fullCalendarRef?.current?.getApi();
            //#endregion variables

            //#region show message
            let msgTextObj = {
                one: `${labels?.title?.[languageObj?.id]}: <b>${description}</b><br/>`,
                two: `${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`,
            };

            let swalProperties = {
                icon: globalSettings?.react?.sweetAlert2?.icons?.warning,
                title: messages?.areYouSureDeleteThis?.[languageObj?.id],
                html: `${msgTextObj?.one}${msgTextObj?.two}`,
                timer: null,
                backdrop: true,
                confirmButtonColor: globalSettings?.colors?.warningColorExp,
                confirmButtonText: labels?.yes?.[languageObj?.id],
                showCancelButton: true, //!Swal.isLoading(), //true,
                cancelButtonColor: globalSettings?.colors?.successColorExp,
                cancelButtonText: labels?.no?.[languageObj?.id],
                showLoaderOnConfirm: true,
                didOpen: () => {
                    Swal.hideLoading();
                },
                preConfirm: async () => {
                    try {
                        Swal.getCancelButton().hidden = true;
                        Swal?.update({
                            icon: globalSettings?.react?.sweetAlert2?.icons?.info,
                            title: `${messages?.processing?.[languageObj?.id]}...`,
                            html: msgTextObj?.one,
                            showConfirmButton: false,
                        });

                        //#region reserve common area (delete)
                        headerObj = {
                            headers: {
                                authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                                languageId: languageObj?.id,
                            },
                            url: `${backend?.url}${backend?.urlApiV1}${backend?.urlReserveCommonAreas}/${id}`,
                        };

                        result = await axios.delete(
                            headerObj?.url,
                            headerObj,
                        );

                        response = result?.data;

                        if (!response?.isSuccess || response?.isWarning) {
                            await sendMessageCloseCurrentWindowAsync({
                                msgType: response?.msgType,
                                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                                closeWindow: false,
                                urlGoTo: response?.urlGoTo,
                                auth: auth,
                                isLogout: false,
                                languageId: languageObj?.id,
                                subMethod: currentMethod,
                            });
                            return;
                        }
                        //#endregion reserve common area (delete)

                        //#region delete event
                        const eventObjLocal = fullCalendarAPILocal?.getEventById(id);
                        eventObjLocal?.remove();
                        //#endregion delete event

                        await sendMessageCloseCurrentWindowAsync({
                            msgType: 0,
                            msgText: `${messages?.processesCompletedSuccessfully?.[languageObj?.id]}.`,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });
                    } catch (ex) {
                        //#region Error
                        response.isSuccess = false;
                        response.msgType = -1;
                        response.msgText = `Method: ${currentMethod}<br/>`;
                        response.msgText += `Error: ${ex?.message}`;
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                        });
                        //#endregion Error
                    }
                },
                allowOutsideClick: () => !Swal.isLoading(),
            };

            await Swal.fire(swalProperties);
            //#endregion show message
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
            return;
        }
    }

    const reserveCommonAreasWithDetailsByIdGetAsync = async ({ id = '', buildingId = '', subMethod = '', }) => {
        const currentMethod = 'reserveCommonAreasWithDetailsByIdGetAsync';
        let response = responseGet();
        try {
            //#region  Get data
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                },
            };

            dataObj = {
                limit: 0,
                ordersBy: [
                    { field: dbProps?.created, value: 'desc' },
                ],
                conditionals: [
                    { field: dbProps?.buildingId, operator: dbOpera?.equalTo, value: buildingId, },
                ],
                withDetails: true,
                id: id,
                buildingId: buildingId,
                languageId: languageObj?.id,
                url: `${backend?.url}${backend?.urlApiV1}${backend?.urlReserveCommonAreas}/`,
            };

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj,
            );

            response = result.data;

            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }
            //#endregion  Get data
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    const reserveCommonAreaDataSetAsync = async ({ property = '', value = '', subMethod = '', }) => {
        const currentMethod = 'reserveCommonAreaDataSetAsync';
        let response = responseGet();
        try {
            //#region variables
            const properties = {
                comment: 'comment',
                status: 'status',
                statusComment: 'statusComment',
                statusUserId: 'statusUserId',
            };
            //#endregion variables

            //#region data set
            if (property === properties?.status) {
                setReserveCommonArea({ ...reserveCommonArea, [property]: parseInt(value), [properties?.statusUserId]: auth?.user?.uid, });
                setStatusUser({ id: auth?.user?.uid, firstName: auth?.user?.displayName, lastName: '', });
            } else {
                setReserveCommonArea({ ...reserveCommonArea, [property]: value, });
            }
            //#endregion data set

            //#region set comment remaining
            if (property === properties?.comment) {
                setCommentRemaining(
                    charactersRemainingGet({
                        text: value,
                        maxLength: commentMaxLength,
                        msgText: `${messages?.charactersRemaining?.[languageObj?.id]}:`,
                        subMethod: currentMethod,
                    })?.result
                );
            }
            //#endregion set comment remaining

            //#region set comment remaining (status)
            if (property === properties?.statusComment) {
                setStatusCommentRemaining(
                    charactersRemainingGet({
                        text: value,
                        maxLength: statusCommentMaxLength,
                        msgText: `${messages?.charactersRemaining?.[languageObj?.id]}:`,
                        subMethod: currentMethod,
                    })?.result
                );
            }
            //#endregion set comment remaining (status)
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const reserveCommonAreaDataSet = async ({ subMethod = '', }) => {
        const currentMethod = 'reserveCommonAreaDataSet';
        let response = responseGet();
        try {
            //#region old code
            //#region variables
            // const paymentDateFrom = $(`#${reserveDateFromId}`)?.datetimepicker('date')?._d;
            // const localDateTo = $(`#${reserveDateToId}`)?.datetimepicker('date')?._d;
            //#endregion variables

            //#region process
            // reserveCommonArea.dateFrom = !isUndefined(paymentDateFrom) ? paymentDateFrom : reserveCommonArea.dateFrom;
            // reserveCommonArea.dateTo = !isUndefined(localDateTo) ? localDateTo : reserveCommonArea.dateTo;
            //#endregion process
            //#endregion old code

            //#region variables
            const dateTimeObj = {
                from: $(`#${reserveDateFromId}`)?.datetimepicker('date')?._d,
                to: $(`#${reserveDateToId}`)?.datetimepicker('date')?._d,
            };
            //#endregion variables

            //#region methods
            reserveCommonArea.dateFrom = !isUndNullEmp({ data: dateTimeObj?.from, subMethod: currentMethod, })?.result ? new Date(dateTimeObj?.from).toISOString() : reserveCommonArea?.dateFrom;
            reserveCommonArea.dateTo = !isUndNullEmp({ data: dateTimeObj?.to, subMethod: currentMethod, })?.result ? new Date(dateTimeObj?.to).toISOString() : reserveCommonArea?.dateTo;
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }
    //#endregion reserver common area (methods)

    //#region user
    // const localUserByIdGetAsync = async (id = '') => {
    //     let response = responseGet();
    //     try {
    //         //#region user get

    //         headerObj = {
    //             headers: {
    //                 authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
    //             },
    //         };
    //         //result = await axios?.get(`${backend?.urlDev}${backend?.urlApiV1}${backend?.urlUsers}/${id}`, headerObj);
    //         result = await axios?.get(`${backend?.url}${backend?.urlApiV1}${backend?.urlUsers}/${id}`, headerObj);
    //         response = result.data;

    //         if (!response?.isSuccess || response?.isWarning) {
    //             return response;
    //         }

    //         //#endregion get user
    //     } catch (ex) {
    //         response.isSuccess = false;
    //         response.msgType = -1;
    //         response.msgText = `Method: localUserByIdGetAsync<br/>`;
    //         response.msgText += `Error: ${ex?.message}`;
    //     }
    //     return response;
    // }
    //#endregion user

    //#region apartments
    //#region  old code
    // const localUserApartmentsGetAsync = async (buildingId = '') => {
    //     let response = responseGet();
    //     try {
    //         headerObj = {
    //             headers: {
    //                 authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
    //             },
    //         };

    //         localData = {
    //             conditionals: [],
    //             ordersBy: [],
    //             buildingId: buildingId,
    //             method: 'apartmentUserWithDetailsGetAsync',
    //             // Stay here
    //             // Do for all users
    //             userId: userRole === globalSettings?.roles?.master ? '' : auth?.user?.uid,
    //             withDetails: true,
    //         }
    //         //result = await axios?.post(`${backend?.urlDev}${backend?.urlApiV1}${backend?.urlApartmentUsers}/`, localData, headerObj);
    //         result = await axios?.post(`${backend?.url}${backend?.urlApiV1}${backend?.urlApartmentUsers}/`, localData, headerObj);
    //         response = result.data;

    //         if (!response?.isSuccess || response?.isWarning) {
    //             return response;
    //         }
    //     } catch (ex) {
    //         response.isSuccess = false;
    //         response.msgType = -1;
    //         response.msgText = `Method: localUserApartmentsGetAsync<br/>`;
    //         response.msgText += `Error: ${ex?.message}`;
    //     }
    //     return response;
    // }
    //#endregion  old code
    //#endregion apartments

    //#region calendar (methods)
    const calendarEventSetAsync = async ({ data = [], subMethod = '', }) => {
        const currentMethod = 'calendarEventSetAsync';
        let response = responseGet();
        try {
            //#region variables
            let calendarEvents = [];
            //#endregion variables

            //#region methods
            if (isUndNullEmp({ data: data, subMethod: currentMethod, })?.result || data?.length <= 0) {
                return response;
            }

            for (let detail of data) {
                response = await evenDataSetAsync({
                    data: detail,
                    subMethod: currentMethod,
                });

                if (!response?.isSuccess || response?.isWarning) {
                    return response;
                }

                calendarEvents?.push(response?.result);
            }

            setCalendarEvents(calendarEvents);
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const calendarEventClickAsync = async ({
        data = {
            event: {
                end: '',
                extendedProps: {
                    apartment: {
                        identifier: '',
                    },
                    comment: '',
                    commonArea: {
                        area: '',
                    },
                    status: {
                        type: '',
                    },
                    user: {
                        firstName: '',
                    },
                },
                start: '',
            },
        },
        subMethod = '', }) => {
        const currentMethod = 'calendarEventClickAsync';
        let response = responseGet();
        try {
            //#region variables
            //#endregion variables

            //#region Form data clear
            response = await formDataClearAsync({
                e: null,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion Form data clear

            //#region set message
            //#region variables
            //const statusObj?.obj = data?.event?.extendedProps?.status;
            //const statusObj.description = processValues.status.filter(({ id, }) => id === statusObj?.obj.type.toString())[0].description;
            const statusObj = {
                obj: data?.event?.extendedProps?.status,
                description: '',
            };

            const squareColorLocal = statusObj?.obj?.type === 0 ? 'text-info' :
                statusObj?.obj?.type === 1 ? 'text-success' :
                    statusObj?.obj?.type === 2 ? 'text-warning' : 'text-danger';
            statusObj.description = processValues?.status?.filter(({ id, }) => id === statusObj?.obj.type?.toString())?.[0]?.description || '';

            const dateTimeObj = {
                dateFormat: languageObj?.format?.date?.f1,
                timeFormat: languageObj?.format?.time?.type,
                start: '',
                end: ''
            };
            dateTimeObj.start = dateTimeFormatGlobalSet({
                date: data?.event?.start,
                type: dateTimeObj?.dateFormat,
                format: dateTimeObj?.timeFormat,
                addTime: false,
                secondsShow: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            })?.result;
            dateTimeObj.end = dateTimeFormatGlobalSet({
                date: data?.event?.end,
                type: dateTimeObj?.dateFormat,
                format: dateTimeObj?.timeFormat,
                addTime: false,
                secondsShow: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            })?.result;
            //#endregion variables

            //#region message
            let msgText = `<div class='table-responsive' style='font-size:14px;'>`;
            msgText += `   <table class='table table-sm'>`;
            msgText += `       <col width='20px'/>`;
            msgText += `       <col width='80px'/>`;
            msgText += `       <tbody class='text-left'>`;
            msgText += `           <tr>`;
            msgText += `               <td><b>${labels?.status?.[languageObj?.id]}:</b></td>`;
            msgText += `               <td><i class='${globalSettings?.icons?.square} ${squareColorLocal}'></i> ${statusObj?.description}</td>`;
            msgText += `           </tr>`;
            msgText += `           <tr>`;
            msgText += `               <td><b>${labels?.apartment?.[languageObj?.id]}:</b></td>`;
            msgText += `               <td>${data?.event?.extendedProps?.apartment?.identifier}</td>`;
            msgText += `           </tr>`;
            msgText += `           <tr>`;
            msgText += `               <td><b>${labels?.user?.[languageObj?.id]}:</b></td>`;
            msgText += `               <td>${data?.event?.extendedProps?.user?.firstName}</td>`;
            msgText += `           </tr>`;
            msgText += `           <tr>`;
            msgText += `               <td><b>${labels?.commonArea?.[languageObj?.id]}:</b></td>`;
            msgText += `               <td>${data?.event?.extendedProps?.commonArea?.area}</td>`;
            msgText += `           </tr>`;
            msgText += `           <tr>`;
            msgText += `               <td><b>${labels?.startDate?.[languageObj?.id]}:</b></td>`;
            msgText += `               <td>${dateTimeObj?.start}</td>`;
            msgText += `           </tr>`;
            msgText += `           <tr>`;
            msgText += `               <td><b>${labels?.endDate?.[languageObj?.id]}:</b></td>`;
            msgText += `               <td>${dateTimeObj?.end}</td>`;
            msgText += `           </tr>`;
            msgText += `           <tr>`;
            msgText += `               <td><b>${labels?.comment?.[languageObj?.id]}:</b></td>`;
            msgText += `               <td>${data?.event?.extendedProps?.comment}</td>`;
            msgText += `           </tr>`;
            msgText += `       </tbody>`;
            msgText += `   </table>`;
            msgText += `</div>`;

            swalProperties = {
                title: labels?.reserve?.[languageObj?.id],
                html: msgText,
                timer: null,
                showConfirmButton: data?.event?.extendedProps?.process?.edit || false,
                confirmButtonColor: globalSettings?.colors?.warningColorExp,
                confirmButtonText: labels?.edit?.[languageObj?.id],
                showCancelButton: true,
                cancelButtonColor: globalSettings?.colors?.successColorExp,
                cancelButtonText: labels?.close?.[languageObj?.id],
                showDenyButton: data?.event?.extendedProps?.process?.delete || false,
                denyButtonColor: globalSettings?.colors?.dangerColorExp,
                denyButtonText: labels?.delete?.[languageObj?.id],
                timerProgressBar: false,
                didOpen: () => {
                    Swal.hideLoading();
                },
            };
            //#endregion message
            //#endregion set message

            //#region process
            const { isConfirmed, isDenied, } = await Swal.fire(swalProperties);
            if (isConfirmed) {
                //#region Edit
                setProcessValues({ ...processValues, type: 1, });
                await reserveCommonAreaAddEditDetailsDeleteGetAsync({ e: null, id: data?.event?.id, description: data?.event?.title, data: data, processType: 1, subMethod: currentMethod, });
                //#endregion Edit
            } else if (isDenied) {
                //#region delete
                setProcessValues({ ...processValues, type: -1, });
                //await reserveCommonAreaAddEditDetailsDeleteGetAsync(null, data?.event?.id, data?.event?.title, data, -1);
                await reserveCommonAreaAddEditDetailsDeleteGetAsync({ e: null, id: data?.event?.id, description: data?.event?.title, data: data, processType: -1, subMethod: currentMethod, });
                //#endregion delete
            }
            //#endregion process
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        //return response;
    }

    const evenDataSetAsync = async ({ data = {}, subMethod = '', }) => {
        const currentMethod = 'evenDataSetAsync';
        let response = responseGet();
        try {
            //#region variables
            const backgroudnColorLocal = data?.status === 0 ? globalSettings?.colors?.infoColorExp :
                data?.status === 1 ? globalSettings?.colors?.successColorExp :
                    data?.status === 2 ? globalSettings?.colors?.warningColorExp :
                        globalSettings?.colors?.dangerColorExp;
            //#endregion variables

            //#region process
            response.result = {
                id: data?.id,
                backgroundColor: backgroudnColorLocal,

                title: data?.commonArea?.area,
                extendedProps: {
                    apartment: {
                        id: data?.apartmentId,
                        ...data?.apartment
                    },
                    buildingId: data?.buildingId,
                    comment: data?.comment,
                    commonArea: data?.commonArea,
                    created: data?.created,
                    process: {
                        edit: data?.process.edit,
                        detail: data?.process.detail,
                        delete: data?.process.delete,
                    },
                    status: {
                        comment: data?.statusComment,
                        date: data?.statusDate,
                        type: data?.status,
                        user: data?.statusUser,
                        userId: data?.statusUserId,
                    },
                    user: {
                        id: data?.userId,
                        ...data?.user,
                    },
                },
                start: data?.dateFrom,
                end: data?.dateTo,
            };
            //#endregion process
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }
    //#endregion calendar (methods)

    //#region methods (others)
    const dataGetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'dataGetAsync';
        let response = responseGet();
        try {
            //#region inicialize
            setBtnSyncDisabled(true);
            setShowData(false);
            setShowLoading({ buildings: true, reserveCommonAreas: true, });
            //#endregion inicialize

            //#region set comment remaining
            setCommentRemaining(
                charactersRemainingGet({
                    text: reserveCommonArea?.comment || '',
                    maxLength: commentMaxLength,
                    msgText: `${messages?.charactersRemaining?.[languageObj?.id]}:`,
                    subMethod: currentMethod,
                })?.result
            );
            //#endregion set comment remaining

            //#region set comment remaining (status)
            setStatusCommentRemaining(
                charactersRemainingGet({
                    text: reserveCommonArea?.statusComment || '',
                    maxLength: statusCommentMaxLength,
                    msgText: `${messages?.charactersRemaining?.[languageObj?.id]}:`,
                    subMethod: currentMethod,
                })?.result
            );
            //#endregion set comment remaining (status)

            //#region buildings get
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                },
            };

            dataObj = {
                conditionals: [],
                ordersBy: [
                    { field: dbProps?.description, value: 'asc' }
                ],
            };

            response = await buildingsByUserGetAsync({
                userRole: userRole,
                auth: auth,
                urlGoTo: backend?.urlReserveCommonAreas,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowData(false);
                setShowLoading({ buildings: false, reserveCommonAreas: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            if (!isUndNullEmp({ data: response?.result?.buildings, subMethod: currentMethod, })?.result && response?.result?.buildings?.length > 0) {
                setBuildings(response?.result?.buildings);
            }
            //#endregion buildings get

            //#region check if PC, laptop, tablet, cell phone
            response = await checkIfCallPrinterAsync({
                checkIfOnlyIsMobile: true,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowData(false);
                setShowLoading({ buildings: false, reserveCommonAreas: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            setEnableCalendarEventMouseEnter(!response?.result);
            //#endregion check if PC, laptop, tablet, cell phone

            setShowData(true);
            setShowLoading({ buildings: false, reserveCommonAreas: false, });
        } catch (ex) {
            setBtnSyncDisabled(true);
            setShowData(false);
            setShowLoading({ buildings: false, reserveCommonAreas: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const dateInControlSetAsync = async ({ date = new Date(), dateFrom = undefined, dateTo = undefined, processType = 0, subMethod = '', }) => {
        const currentMethod = 'dateInControlSetAsync';
        let response = responseGet();
        try {
            //#region variables
            //#region old code
            //let dateTimeObj?.from = '';
            //let dateTimeObj?.to = '';
            //const dateTimeObj?.format = globalSettings?.react?.tempusDominus?.format?.date?.dmy;
            //const dateTimeObj?.formatTwo = globalSettings?.react?.tempusDominus?.format?.date?.DDMMYYYY;
            //const dateTimeObj?.timeFormatTwo = globalSettings?.react?.tempusDominus?.format?.time?.hhmmA;
            //#endregion old code

            const dateTimeObj = {
                from: '',
                to: '',
                format: languageObj?.format?.date?.f1,
                formatTwo: languageObj?.format?.date?.f11,
                timeFormat: languageObj?.format?.time?.type,
                timeFormatTwo: languageObj?.format?.time?.f3,
            };
            //#endregion variables

            //#region process
            if (!isUndNullEmp({ data: dateFrom, subMethod: currentMethod, })?.result) {
                dateTimeObj.from = dateTimeFormatGlobalSet({
                    date: dateFrom,
                    type: dateTimeObj?.format,
                    format: dateTimeObj?.timeFormat,
                    addTime: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;
            } else if (!isUndNullEmp({ data: date, subMethod: currentMethod, })?.result) {
                dateTimeObj.from = dateTimeFormatGlobalSet({
                    date: date,
                    type: dateTimeObj?.format,
                    format: dateTimeObj?.timeFormat,
                    addTime: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;
            }

            if (!isUndNullEmp({ data: dateTo, subMethod: currentMethod, })?.result) {
                dateTimeObj.to = dateTimeFormatGlobalSet({
                    date: dateTo,
                    type: dateTimeObj?.format,
                    format: dateTimeObj?.timeFormat,
                    addTime: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;
            } else if (!isUndNullEmp({ data: date, subMethod: currentMethod, })?.result) {
                dateTimeObj.to = dateTimeFormatGlobalSet({
                    date: date,
                    type: dateTimeObj?.format,
                    format: dateTimeObj?.timeFormat,
                    addTime: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;
            }

            if (processType === 0) {
                $.fn.datetimepicker.Constructor.Default = $.extend({}, $.fn.datetimepicker.Constructor.Default, {
                    icons: globalSettings?.react?.tempusDominus?.icons,
                    buttons: globalSettings?.react?.tempusDominus?.buttons,
                    tooltips: globalSettings?.react?.tempusDominus?.tooltips,
                    locale: languageObj?.id,
                });

                $(`#${reserveDateFromId}`)?.datetimepicker({
                    date: moment(`${dateTimeObj?.from}`, `${dateTimeObj?.formatTwo} ${dateTimeObj?.timeFormatTwo}`),
                    default: false,
                    format: `${dateTimeObj?.formatTwo} ${dateTimeObj?.timeFormatTwo}`,
                });

                $(`#${reserveDateToId}`)?.datetimepicker({
                    date: moment(`${dateTimeObj?.to}`, `${dateTimeObj?.formatTwo} ${dateTimeObj?.timeFormatTwo}`),
                    default: false,
                    format: `${dateTimeObj?.formatTwo} ${dateTimeObj?.timeFormatTwo}`,
                });
            } else {
                $(`#${reserveDateFromId}`).datetimepicker(
                    'date',
                    moment(`${dateTimeObj?.from}`, `${dateTimeObj?.formatTwo} ${dateTimeObj?.timeFormatTwo}`),
                );
                $(`#${reserveDateToId}`).datetimepicker(
                    'date',
                    moment(`${dateTimeObj?.to}`, `${dateTimeObj?.formatTwo} ${dateTimeObj?.timeFormatTwo}`),
                );
            }
            //#endregion process
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const formDataClearAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'formDataClearAsync';
        let response = responseGet();
        try {
            //#region set initial
            if (!isUndNullEmp({ e: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }
            //#endregion set initial

            //#region clear data
            setProcessValues({ ...processValues, type: 0, });
            setReserveCommonArea(
                reserveCommonAreaModelGet({
                    buildingId: building?.id,
                    apartmentId: '',
                    commonAreaId: '',
                    userId: auth?.user?.uid,
                })
            );
            setStatusUser({});
            $(`#${controls?.selects?.apartment?.id}`)?.val('');
            $(`#${controls?.selects?.commonArea?.id}`)?.val('');
            //$(`#${controls?.selects?.status?.id}`)?.val('');
            $(`#${controls?.selects?.status?.id}`)?.val('-1');
            //#endregion clear data

            //#region dateTime in control set
            response = await dateInControlSetAsync({
                date: new Date(),
                dateFrom: undefined,
                dateTo: undefined,
                processType: 1,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                //await sendMessageCloseCurrentWindowAsync(response.msgType, response.msgText, false, response.urlGoTo, auth, false);
                return;
            }
            //#endregion dateTime in control set

            //#region set comment remaining
            setCommentRemaining(
                charactersRemainingGet({
                    text: '',
                    maxLength: commentMaxLength,
                    msgText: `${messages?.charactersRemaining?.[languageObj?.id]}:`,
                    subMethod: currentMethod,
                })?.result
            );
            //#endregion set comment remaining

            //#region set comment remaining (status)
            setStatusCommentRemaining(
                charactersRemainingGet({
                    text: '',
                    maxLength: statusCommentMaxLength,
                    msgText: `${messages?.charactersRemaining?.[languageObj?.id]}:`,
                    subMethod: currentMethod,
                })?.result
            );
            //#endregion set comment remaining (status)

            //#region error default set
            response = await errorDefaultSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                //await sendMessageCloseCurrentWindowAsync(response.msgType, response.msgText, false, response.urlGoTo, auth, false);
                return;
            }
            //#endregion error default set

            //#region set initialize
            setStatusCommentShow(isChangeStatus);
            //#endregion set initialize
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const errorDefaultSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'errorDefaultSetAsync';
        let response = responseGet();
        try {
            setApartmentUsersError('');
            setCommonAreasError('');
            setDateFromError('');
            setDateToError('');
            setCommonAreasError('');
            setStatusError('');
            setStatusCommentError('');
            setStatusUserError('');
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const formDataValidateAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'formDataValidateAsync';
        let response = responseGet();
        try {
            //#region variables
            //const dateTimeObj?.from = $(`#${reserveDateFromInputId}`)?.val();
            //const dateTimeObj?.to = $(`#${reserveDateToInputId}`)?.val();
            const dateTimeObj = {
                from: $(`#${controls?.inputs?.dateFrom?.id}`).val(),
                to: $(`#${controls?.inputs?.dateTo?.id}`).val(),
            };
            //#endregion variables

            //#region methods
            if (isUndNullEmp({ data: reserveCommonArea?.apartmentId, subMethod: currentMethod, })?.result) {
                setApartmentUsersError(`${messages?.thisFieldRequired?.[languageObj?.id]}`);
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: reserveCommonArea?.commonAreaId, subMethod: currentMethod, })?.result) {
                setCommonAreasError(`${messages?.thisFieldRequired?.[languageObj?.id]}`);
                response.isWarning = true;
            }

            //#region old code
            // if (isUndefined(dateTimeObj?.from) || isNull(dateTimeObj?.from) || isEmpty(dateTimeObj?.from) ||
            //     isUndefined(reserveCommonArea.dateFrom) || isNull(reserveCommonArea.dateFrom)) {
            //     setDateFromError(messages?.thisFieldRequired?.[languageObj?.id]);
            //     response.isWarning = true;
            // }

            // if (isUndefined(dateTimeObj?.to) || isNull(dateTimeObj?.to) || isEmpty(dateTimeObj?.to) ||
            //     isUndefined(reserveCommonArea.dateTo) || isNull(reserveCommonArea.dateTo)) {
            //     setDateToError(messages?.thisFieldRequired?.[languageObj?.id]);
            //     response.isWarning = true;
            // }
            //#endregion old code

            //#region old code
            // if (moment(new Date(reserveCommonArea.dateFrom).toUTCString()).isSame(new Date(reserveCommonArea.dateTo).toUTCString())) {
            //     setDateFromError(messages?.theseFieldsCanNotBeTheSame?.[languageObj?.id]);
            //     setDateToError(messages?.theseFieldsCanNotBeTheSame?.[languageObj?.id]);
            //     response.isWarning = true;
            // }
            //#endregion old code

            //#region old code
            // if (moment(new Date(reserveCommonArea.dateTo).toUTCString()).isBefore(new Date(reserveCommonArea.dateFrom).toUTCString())) {
            //     setDateFromError(messages?.dateToMustBeGreaterThanDateFrom?.[languageObj?.id]);
            //     setDateToError(messages?.dateToMustBeGreaterThanDateFrom?.[languageObj?.id]);
            //     response.isWarning = true;
            // }
            //#endregion old code

            if (isUndNullEmp({ data: dateTimeObj?.from, subMethod: currentMethod, })?.result ||
                isUndNullEmp({ data: reserveCommonArea?.dateFrom, subMethod: currentMethod, })?.result) {
                setDateFromError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }
            if (isUndNullEmp({ data: dateTimeObj?.to, subMethod: currentMethod, })?.result ||
                isUndNullEmp({ data: reserveCommonArea?.dateTo, subMethod: currentMethod, })?.result) {
                setDateToError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }
            if (moment(new Date(reserveCommonArea?.dateFrom).toUTCString()).isSame(new Date(reserveCommonArea?.dateTo).toUTCString())) {
                setDateFromError(messages?.theseFieldsCanNotBeTheSame?.[languageObj?.id]);
                setDateToError(messages?.theseFieldsCanNotBeTheSame?.[languageObj?.id]);
                response.isWarning = true;
            }
            if (moment(new Date(reserveCommonArea?.dateTo).toUTCString()).isBefore(new Date(reserveCommonArea?.dateFrom).toUTCString())) {
                setDateFromError(messages?.dateToMustBeGreaterThanDateFrom?.[languageObj?.id]);
                setDateToError(messages?.dateToMustBeGreaterThanDateFrom?.[languageObj?.id]);
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: reserveCommonArea?.comment, subMethod: currentMethod, })?.result) {
                setCommentError(`${messages?.thisFieldRequired?.[languageObj?.id]}`);
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: reserveCommonArea?.status, subMethod: currentMethod, })?.result || parseInt(reserveCommonArea?.status) <= -1) {
                setStatusError(`${messages?.thisFieldRequired?.[languageObj?.id]}`);
                response.isWarning = true;
            } else if (!isUndNullEmp({ data: reserveCommonArea?.status, subMethod: currentMethod, })?.result &&
                (parseInt(reserveCommonArea?.status) >= 2 && parseInt(reserveCommonArea?.status) <= 3)) {
                if (isUndNullEmp({ data: reserveCommonArea?.statusComment, subMethod: currentMethod, })?.result) {
                    setStatusCommentError(`${messages?.thisFieldRequired?.[languageObj?.id]}`);
                    response.isWarning = true;
                }
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const controlsStatusSet = ({ processType = 0, subMethod = '', }) => {
        let response = responseGet();
        const currentMethod = 'controlsStatusSet';
        try {
            //#region variables
            //#endregion variables

            //#region methods
            switch (processType) {
                case 0:
                    for (let ctrStr in controls) {
                        const objStr = ['buttons', 'spinners', 'icons'];
                        if (objStr?.includes(ctrStr)) {
                            for (let propStr in controls?.[ctrStr]) {
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.removeClass();
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.addClass(controls?.[ctrStr]?.[propStr]?.className);
                            }
                        }
                    }
                    break;
                case 1:
                    //$(`#${controls?.buttons?.save?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled} ${settings.react.html.button.classes.progress}`);
                    $(`#${controls?.icons?.save?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.save?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                case 2:
                    $(`#${controls?.icons?.new?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.new?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                default:
                    break;
            }

            //#region controls
            $(`#${controls?.selects?.apartment?.id}`).attr('disabled', (processType !== 0));
            $(`#${controls?.selects?.commonArea?.id}`).attr('disabled', (processType !== 0));
            $(`#${controls?.inputs?.dateFrom?.id}`)?.attr('readOnly', (processType !== 0));
            $(`#${controls?.inputs?.dateTo?.id}`)?.attr('readOnly', (processType !== 0));
            $(`#${controls?.inputs?.comment?.id}`)?.attr('readOnly', (processType !== 0));
            $(`#${controls?.selects?.status?.id}`).attr('disabled', (processType !== 0));
            $(`#${controls?.inputs?.commentStatus?.id}`)?.attr('readOnly', (processType !== 0));
            //#endregion controls

            //#region url (register / passwords)
            // $(`#${controls?.urls?.forgotYourPassword?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlForgotPassword));
            // $(`#${controls?.urls?.userRegister?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlUserRegister));
            // $(`#${controls?.urls?.registerStatus?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlRegisterStatus));
            //#endregion url (register / passwords)

            //#region url (rechaptcha)
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.react?.reCAPTCHA?.urlPrivaciConditions));
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('target', (processType !== 0 ? '' : '_blank'));
            //#endregion url (rechaptcha)

            //#region urls
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr({
            //     'href': (processType !== 0 ? urlStop : globalSettings?.app?.reCAPTCHA?.urlPrivaciConditions),
            //     'target': (processType !== 0 ? '' : '_blank'),
            // });
            //#endregion urls

            //#region dataTable buttons
            // btnExcel.node.disabled = processType !== 0;
            // btnPdf.node.disabled = processType !== 0;
            //#endregion dataTable buttons

            //#region dataTable
            // $(`#${controls?.dataTables?.applicants?.inputs?.search?.id}`)?.attr('readOnly', (processType !== 0));
            // $(`#${controls?.dataTables?.applicants?.selects?.entries?.id}`)?.attr('disabled', (processType !== 0));
            //#endregion dataTable

            if (processType !== 0) {
                $(`#${controls?.buttons?.save?.id}`)?.addClass(globalSettings?.react?.html?.button?.classes?.disabled);
                $(`#${controls?.buttons?.new?.id}`)?.addClass(globalSettings?.react?.html?.button?.classes?.disabled);
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console?.error(response);
        }
        return response;
    }

    useEffect(() => {
        dataGetAsync({ subMethod: 'form - onLoad', });
    }, [auth]) //eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods (others)

    return (
        <div>
            <Menu viewName='condominiumBoard' process='reserveCommonAreas' />

            <div className='content-wrapper'>

                {/* Content Header (Page header) */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2'>
                            <div className='col-sm-6'>
                                <h6 className='m-0'>{labels?.reserveCommonAreas?.[languageObj?.id]}</h6>
                            </div>{/* /.col */}
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right'>
                                    <li className='breadcrumb-item'><Link to='/'>{labels?.home?.[languageObj?.id]}</Link></li>
                                    <li className='breadcrumb-item active'>{labels?.reserveCommonAreas?.[languageObj?.id]}</li>
                                </ol>
                            </div>{/* /.col */}
                        </div>{/* /.row */}
                    </div>{/* /.container-fluid */}
                </div>
                {/* /.content-header */}

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>

                        {/*buildings*/}
                        <BuildingHeader buildingsId={buildingsId}
                            building={building}
                            buildings={buildings}
                            btnSyncDisabled={btnSyncDisabled}
                            methodGetAsync={reserveCommonAreasGetAsync}
                            processType={0}
                            headerSectionValues={{}}
                            showLoading={showLoading?.buildings}
                            languageObj={languageObj} />

                        {/*Reserver common area*/}
                        <div className='row'>
                            <div className='col-12'>
                                <div className='card card-outline card-primary shadow-lg'>
                                    <LoadingSection alt='loadingSection'
                                        className={globalSettings?.react?.html?.overlay?.darkTextWhite}
                                        showText={true}
                                        text={messages?.processing?.[languageObj?.id]}
                                        height={25}
                                        hidden={!showLoading?.reserveCommonAreas}
                                        width={25}
                                        languageId={languageObj?.id}
                                        subMethod={currentMethod} />

                                    {/*header*/}
                                    <div className='card-header'>
                                        <h6 className='card-title'>
                                            <img alt={labels?.reserveCommonAreas?.[languageObj?.id]} style={styles?.cardHeaderLogo} src={globalSettings?.images?.reserved}></img>
                                            - {labels?.reserveCommonAreas?.[languageObj?.id]}
                                        </h6>
                                        <div className='card-tools'>
                                            <button type='button' className='btn btn-tool' data-card-widget='collapse'>
                                                <i className={globalSettings?.icons?.minus}></i>
                                            </button>
                                        </div>
                                    </div> {/*card header*/}

                                    {/*body*/}
                                    <div className='card-body'>
                                        {/* {!showLoading ? */}
                                        {showData && !isUndNullEmp({ data: buildingId, subMethod: 'card - body', })?.result && !btnSyncDisabled ?
                                            <div className='row'>
                                                <div className='col-md-3'>
                                                    <div className='sticky-top mb-3'>
                                                        {/* <form onSubmit={(e) => reserveCommonAreaEditAsync(e, '', '')}> */}
                                                        <form onSubmit={(e) => (processValues.type === 0 ?
                                                            reserveCommonAreaAddAsync({ e: e, subMethod: 'form - onSubmit', }) :
                                                            reserveCommonAreaEditAsync({ e: e, id: '', description: '', subMethod: 'form - onSubmit', }))}>
                                                            <div className='card'>
                                                                <div className='card-header'>
                                                                    <h6 className='card-title'>
                                                                        {labels?.reserve?.[languageObj?.id]} - ({
                                                                            processValues.type === 0 ?
                                                                                labels?.add?.[languageObj?.id] :
                                                                                (processValues.type === 1 ? labels?.edit?.[languageObj?.id] : labels?.add?.[languageObj?.id])
                                                                        })
                                                                    </h6>
                                                                </div>

                                                                <div className='card-body'>
                                                                    <div className='form-group'>
                                                                        <div className='input-group mb-3'>
                                                                            <select id={controls?.selects?.apartment?.id}
                                                                                className={controls?.selects?.apartment?.className}
                                                                                onChange={(e) => reserveCommonAreaDataSetAsync({ property: 'apartmentId', value: e?.target?.value, subMethod: 'sel - apartment', })}
                                                                                onFocus={() => setApartmentUsersError()}
                                                                                tooltip='tooltip'
                                                                                title={labels?.apartment?.[languageObj?.id]}
                                                                                value={reserveCommonArea?.apartmentId || ''}>
                                                                                <option key='' value=''>{messages?.selectApartment?.[languageObj?.id]}</option>
                                                                                {apartmentUsers?.map((detail) => <option key={detail?.id} value={detail?.apartmentId}> {detail?.apartment?.identifier} </option>)}
                                                                            </select>
                                                                            <div className='input-group-append'>
                                                                                <div className='input-group-text'>
                                                                                    <span className={globalSettings?.icons?.houseUser} />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(apartmentUsersError)}</div>
                                                                    </div>

                                                                    <div className='form-group'>
                                                                        <div className='input-group mb-3'>
                                                                            <select id={controls?.selects?.commonArea?.id}
                                                                                className={controls?.selects?.commonArea?.className}
                                                                                onChange={(e) => reserveCommonAreaDataSetAsync({ property: 'commonAreaId', value: e?.target?.value, subMethod: 'sel - commonArea', })}
                                                                                onFocus={() => setCommonAreasError()}
                                                                                tooltip='tooltip'
                                                                                title={labels?.commonArea?.[languageObj?.id]}
                                                                                value={reserveCommonArea?.commonAreaId || ''}>
                                                                                <option key='' value=''>{messages?.selectCommonArea?.[languageObj?.id]}</option>
                                                                                {commonAreas?.map((detail) => <option key={detail.id} value={detail.id}> {detail.area} </option>)}
                                                                            </select>
                                                                            <div className='input-group-append'>
                                                                                <div className='input-group-text'>
                                                                                    <span className={globalSettings?.icons?.glassCheers} />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(commonAreasError)}</div>
                                                                    </div>

                                                                    <div className='form-group'>
                                                                        {/* <DatePicker /> */}
                                                                        <div className='input-group mb-3'>
                                                                            <div id={reserveDateFromId}
                                                                                className='input-group date'
                                                                                data-target-input='nearest'>
                                                                                <input id={controls?.inputs?.dateFrom?.id}
                                                                                    className={controls?.inputs?.dateFrom?.className}
                                                                                    data-target={`#${reserveDateFromId}`}
                                                                                    data-toggle='datetimepicker'
                                                                                    onFocus={() => {
                                                                                        setDateToError('');
                                                                                        setDateFromError('');
                                                                                    }}
                                                                                    placeholder={labels?.startDate?.[languageObj?.id]}
                                                                                    tooltip='tooltip'
                                                                                    title={labels?.startDate?.[languageObj?.id]}
                                                                                    type='text' />
                                                                                <div className='input-group-append'
                                                                                    data-target={`#${reserveDateFromId}`}
                                                                                    data-toggle='datetimepicker'>
                                                                                    <div className='input-group-text'>
                                                                                        <i className={globalSettings?.icons?.calendarAlt}></i>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(dateFromError)}</div>
                                                                    </div>

                                                                    <div className='form-group'>
                                                                        {/* <DatePicker /> */}
                                                                        <div className='input-group mb-3'>
                                                                            <div id={reserveDateToId}
                                                                                className='input-group date'
                                                                                data-target-input='nearest'>
                                                                                <input id={controls?.inputs?.dateTo?.id}
                                                                                    className={controls?.inputs?.dateTo?.className}
                                                                                    data-target={`#${reserveDateToId}`}
                                                                                    data-toggle='datetimepicker'
                                                                                    onFocus={() => {
                                                                                        setDateToError('');
                                                                                        setDateFromError('');
                                                                                    }}
                                                                                    placeholder={labels?.endDate?.[languageObj?.id]}
                                                                                    tooltip='tooltip'
                                                                                    title={labels?.endDate?.[languageObj?.id]}
                                                                                    type='text' />
                                                                                <div className='input-group-append'
                                                                                    data-target={`#${reserveDateToId}`}
                                                                                    data-toggle='datetimepicker'>
                                                                                    <div className='input-group-text'>
                                                                                        <i className={globalSettings?.icons?.calendarAlt}></i>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(dateToError)}</div>
                                                                    </div>

                                                                    <div className='form-group'>
                                                                        <div className='input-group mb-3'>
                                                                            <textarea id={controls?.inputs?.comment?.id}
                                                                                className={controls?.inputs?.comment?.className}
                                                                                maxLength={commentMaxLength}
                                                                                onChange={(e) => reserveCommonAreaDataSetAsync({ property: 'comment', value: e?.target?.value, subMethod: 'textArea - comment', })}
                                                                                onFocus={() => setCommentError('')}
                                                                                placeholder={labels?.comment?.[languageObj?.id]}
                                                                                rows={3}
                                                                                tooltip='tooltip'
                                                                                title={labels?.comment?.[languageObj?.id]}
                                                                                value={reserveCommonArea.comment || ''}>
                                                                            </textarea>
                                                                            <div className='input-group-append'>
                                                                                <div className='input-group-text'>
                                                                                    <span className={globalSettings?.icons?.edit} />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className='form-text' style={styles.labelMsgInfo}>{HtmlParser(commentRemaining)}</div>
                                                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(commentError)}</div>
                                                                    </div>

                                                                    {isChangeStatus || statusCommentShow ?
                                                                        <div className='form-group'>
                                                                            <hr />
                                                                        </div>
                                                                        :
                                                                        <></>
                                                                    }

                                                                    {isChangeStatus || statusCommentShow ?
                                                                        <div className='form-group'>
                                                                            <div className='input-group mb-3'>
                                                                                <select id={controls?.selects?.status?.id}
                                                                                    className={controls?.selects?.status?.className}
                                                                                    disabled={!isChangeStatus}
                                                                                    onChange={(e) => reserveCommonAreaDataSetAsync({ property: 'status', value: e?.target?.value, subMethod: 'sel - status', })}
                                                                                    onFocus={() => setStatusError()}
                                                                                    tooltip='tooltip'
                                                                                    title={labels?.status?.[languageObj?.id]}
                                                                                    value={`${reserveCommonArea?.status}` || '-1'}>
                                                                                    <option key='-1' value='-1'>{messages?.selectStatus?.[languageObj?.id]}</option>
                                                                                    {processValues?.status?.map((detail) => <option key={`${detail?.id}`} value={`${detail?.id}`}> {detail?.description} </option>)}
                                                                                </select>
                                                                                <div className='input-group-append'>
                                                                                    <div className='input-group-text'>
                                                                                        <span className={globalSettings?.icons?.toggleOn} />
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(statusError)}</div>
                                                                        </div>
                                                                        :
                                                                        <></>
                                                                    }

                                                                    {isChangeStatus || statusCommentShow ?
                                                                        <div className='form-group'>
                                                                            <div className='input-group mb-3'>
                                                                                <textarea id={controls?.inputs?.commentStatus?.id}
                                                                                    className={controls?.inputs?.commentStatus?.className}
                                                                                    maxLength={statusCommentMaxLength}
                                                                                    onChange={(e) => reserveCommonAreaDataSetAsync({ property: 'statusComment', value: e?.target?.value, subMethod: 'textArea - statusComment', })}
                                                                                    onFocus={() => setStatusCommentError('')}
                                                                                    placeholder={`${labels?.comment?.[languageObj?.id]} (${labels?.status?.[languageObj?.id]})`}
                                                                                    readOnly={!isChangeStatus}
                                                                                    rows={3}
                                                                                    tooltip='tooltip'
                                                                                    title={`${labels?.comment?.[languageObj?.id]} (${labels?.status?.[languageObj?.id]})`}
                                                                                    value={reserveCommonArea.statusComment || ''}>
                                                                                </textarea>
                                                                                <div className='input-group-append'>
                                                                                    <div className='input-group-text'>
                                                                                        <span className={globalSettings?.icons?.edit} />
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className='form-text' style={styles.labelMsgInfo}>{HtmlParser(statusCommentRemaining)}</div>
                                                                            <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(statusCommentError)}</div>
                                                                        </div>
                                                                        :
                                                                        <></>
                                                                    }

                                                                    {isChangeStatus || statusCommentShow ?
                                                                        <div className='form-group'>
                                                                            <div className='input-group mb-3'>
                                                                                <input className='form-control bg-transparent text-black'
                                                                                    onFocus={() => setStatusUserError('')}
                                                                                    placeholder={`${labels?.user?.[languageObj?.id]} (${labels?.status?.[languageObj?.id]})`}
                                                                                    readOnly
                                                                                    tooltip='tooltip'
                                                                                    title={`${labels?.user?.[languageObj?.id]} (${labels?.status?.[languageObj?.id]})`}
                                                                                    value={!isUndNullEmp({ data: reserveCommonArea?.statusUserId, subMethod: 'input - statusUser', })?.result ?
                                                                                        `${statusUser?.firstName || ''}, ${statusUser?.lastName || ''}` : ''}>
                                                                                </input>
                                                                                <div className='input-group-append'>
                                                                                    <div className='input-group-text'>
                                                                                        <span className={globalSettings?.icons?.userTag} />
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(statusUserError)}</div>
                                                                        </div>
                                                                        :
                                                                        <></>
                                                                    }

                                                                </div>

                                                                <div className='card-footer text-right'>
                                                                    <button id={controls?.buttons?.save?.id}
                                                                        className={controls?.buttons?.save?.className}
                                                                        tooltip='tooltip'
                                                                        title={labels?.save?.[languageObj?.id]}
                                                                        type='submit'>
                                                                        <i id={controls?.icons?.save?.id} className={controls?.icons?.save?.className} /> <span id={controls?.spinners?.save?.id} className='' aria-hidden='true'></span>
                                                                    </button>
                                                                    <button id={controls?.buttons?.new?.id}
                                                                        className={controls?.buttons?.new?.className}
                                                                        onClick={(e) => formDataClearAsync({ e: e, subMethod: 'btn - new' })}
                                                                        tooltip='tooltip'
                                                                        type='button'
                                                                        title={labels?.new?.[languageObj?.id]}>
                                                                        <i id={controls?.icons?.new?.id} className={controls?.icons?.new?.className} /> <span id={controls?.spinners?.new?.id} className='' aria-hidden='true'></span>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </form>
                                                    </div>
                                                </div>
                                                <div className='col-md-9'>
                                                    <div className='card card-primary'>
                                                        <div className='card-body p-0'>
                                                            <FullCalendar buttonText={calendarSettings?.buttonText}
                                                                droppable={calendarSettings?.droppable}
                                                                editable={calendarSettings?.editable}
                                                                events={calendarSettings?.events}
                                                                eventClick={calendarSettings?.eventClick}
                                                                eventMouseEnter={calendarSettings?.eventMouseEnter}
                                                                eventMouseLeave={calendarSettings?.eventMouseLeave}
                                                                headerToolbar={calendarSettings?.headerToolbar}
                                                                initialView={calendarSettings?.initialView}
                                                                locale={calendarSettings?.locale}
                                                                locales={calendarSettings?.locales}
                                                                plugins={calendarSettings?.plugins}
                                                                ref={fullCalendarRef}
                                                                rerenderDelay={2}
                                                                themeSystem={calendarSettings?.themeSystem} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            :
                                            <div></div>
                                        }
                                        {/* : */}
                                        {/* <CssfxLoading type={globalSettings?.react?.CssfxLoading?.circularProgress}
                                                width={40}
                                                height={40}
                                                color={globalSettings?.colors?.infoColorExp}
                                                msgText={messages?.processing?.[languageObj?.id]}
                                                msgOrientation='text-center'
                                                msgTextMuted={true} /> */}
                                        {/* } */}
                                    </div>

                                    {/*footer*/}
                                    <div className='card-footer'></div>
                                </div>
                            </div>
                        </div>

                    </div>{/* /.container-fluid*/}
                </section>{/* /.content*/}

            </div>{/* /.content-wrapper*/}

        </div>
    )
}